import { deleteOrderStatusesApi, getOrderStatusesApi } from "@/api/orders";
import { storeToRefs } from "pinia";
import { useOrderStatusesStore } from "@/store/orderStatuses";
import useToast from "@/hooks/useToast";
import router from "@/router";

export const useOrdersStatusesActions = () => {
  const { loading, items, pagination } = storeToRefs(useOrderStatusesStore());
  const { openToast } = useToast();
  const loadOrderStatuses = (params) => {
    loading.value = true;
    return getOrderStatusesApi(params)
      .then((response) => {
        const { pagination: _pagination, orderStatuses } = response.data;
        pagination.value = _pagination;
        items.value = orderStatuses;
        return response;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        loading.value = false;
      });
  };
  const deleteOrderStatus = (id) => {
    return deleteOrderStatusesApi(id)
      .catch((err) => {
        openToast(err.message);
      })
      .finally(() => {
        // Reload the page of the list the user is on.
        loadOrderStatuses(new URLSearchParams(router.currentRoute.value.query));
      });
  };
  return { loadOrderStatuses, deleteOrderStatus, items, pagination, loading };
};
